module.exports = __webpack_public_path__ + "media/images/header/impact_local-a8ceebf6f428ae28e64fa7233ca69533.svg";